/**
 * Paraschiena Upsell — Aventurx Theme
 *
 * Mostra il box upsell del paraschiena abbinato alla giacca e gestisce
 * l'aggiunta di entrambi i prodotti al carrello in un'unica chiamata AJAX.
 *
 * Dipendenze: nessuna (vanilla JS, no jQuery).
 * Integrazione: lo snippet paraschiena-upsell.liquid fa il render e include questo file.
 */
(function () {
  'use strict';

  /* ─── helpers ─── */

  function formatMoney(cents) {
    return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* ─── classe principale ─── */

  function ParaschienaUpsell(container) {
    var productId = container.dataset.productId;
    var configEl = document.getElementById('paraschiena-upsell-data-' + productId);
    if (!configEl) return;

    var cfg;
    try {
      cfg = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    /* Determina la categoria di mapping (men/ladies × textile/leather) */
    var gender      = cfg.isLadies  ? 'ladies' : 'men';
    var material    = cfg.isLeather ? 'leather' : 'textile';
    var categoryKey = gender + '_' + material;

    var vendorMapping = cfg.sizeMapping[cfg.vendor] || {};
    var sizeMap     = vendorMapping[categoryKey] || vendorMapping['universal'] || {};
    var variantData = cfg.protectorVariants || {};
    var jacketVars  = cfg.jacketVariants   || {};

    /* Elementi DOM */
    var formContainer = container.closest('[data-ajax-add-to-cart]');
    if (!formContainer) return;

    /* v5.2: il form usa la classe js-product-form (non più product-purchase-form) */
    var form = formContainer.querySelector('form.js-product-form');
    if (!form) return;

    var elNoRadio  = container.querySelector('input[value="no"]');
    var elYesRadio = container.querySelector('input[value="yes"]');
    var elPrice    = container.querySelector('.paraschiena-upsell__price');
    var elOosMsg   = container.querySelector('.paraschiena-upsell__oos-msg');
    var elOptions  = container.querySelector('.paraschiena-upsell__options');
    var elError    = container.querySelector('.paraschiena-upsell__error');

    var selectedProtectorVariantId = null;
    /* v5.2: variante corrente giacca tracciata tramite on:variant:change */
    var currentJacketVariantId = null;

    /* ── aggiorna il box in base all'ID variante giacca ── */
    function update(jacketVariantId) {
      if (!jacketVariantId) {
        container.style.display = 'none';
        return;
      }

      var jacketSize       = jacketVars[jacketVariantId];
      var protectorSize    = jacketSize ? sizeMap[jacketSize] : null;
      var protectorVariant = protectorSize ? variantData[protectorSize] : null;

      if (!protectorVariant) {
        /* Nessun mapping valido per questa taglia → nascondi il box */
        container.style.display = 'none';
        selectedProtectorVariantId = null;
        return;
      }

      container.style.display = '';
      clearError();

      if (protectorVariant.available) {
        selectedProtectorVariantId = protectorVariant.id;
        elYesRadio.disabled        = false;
        elYesRadio.checked         = true;
        elPrice.textContent        = formatMoney(protectorVariant.price);
        elOosMsg.style.display     = 'none';
        elOosMsg.setAttribute('aria-hidden', 'true');
        elOptions.style.display    = '';
      } else {
        /* Esaurito */
        selectedProtectorVariantId = null;
        elYesRadio.disabled        = true;
        elNoRadio.checked          = true;
        elPrice.textContent        = 'Esaurito';
        elOosMsg.style.display     = '';
        elOosMsg.removeAttribute('aria-hidden');
      }
    }

    /* ── messaggi di errore inline ── */
    function showError(msg) {
      if (!elError) return;
      elError.textContent   = msg;
      elError.style.display = '';
      setTimeout(function () { elError.style.display = 'none'; }, 5000);
    }

    function clearError() {
      if (elError) elError.style.display = 'none';
    }

    /* ── intercetta il submit del form quando "Sì" è selezionato ── */
    function onSubmit(evt) {
      if (!elYesRadio.checked) return; /* delega al comportamento normale */

      /* v5.2: legge dalla variabile tracciata, non da originalSelector.value */
      var jacketVariantId = currentJacketVariantId;

      if (!jacketVariantId) {
        /* Taglia giacca non ancora selezionata */
        evt.preventDefault();
        evt.stopImmediatePropagation();
        showError('Seleziona prima la taglia della giacca');
        return;
      }

      if (!selectedProtectorVariantId) return; /* non dovrebbe accadere */

      evt.preventDefault();
      evt.stopImmediatePropagation();

      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.classList.add('btn--in-progress');
        submitBtn.disabled = true;
      }

      var quantity = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            { id: parseInt(jacketVariantId, 10), quantity: quantity },
            { id: selectedProtectorVariantId,    quantity: 1 }
          ]
        })
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { return Promise.reject(d); });
        return r.json();
      })
      .then(function () {
        /* Aggiorna carrello / apri drawer — stesso evento usato dal tema */
        document.documentElement.dispatchEvent(
          new CustomEvent('theme:cartchanged', {
            bubbles: true,
            cancelable: false,
            detail: { openDrawer: true }
          })
        );
        if (submitBtn) {
          submitBtn.classList.remove('btn--in-progress');
          submitBtn.disabled = false;
        }
      })
      .catch(function (err) {
        if (submitBtn) {
          submitBtn.classList.remove('btn--in-progress');
          submitBtn.disabled = false;
        }
        var msg = (err && (err.description || err.message)) || 'Errore durante l\'aggiunta al carrello';
        /* Usa il popup del tema se disponibile, altrimenti messaggio inline */
        if (typeof theme !== 'undefined' && typeof theme.showQuickPopup === 'function' && submitBtn) {
          theme.showQuickPopup(msg, submitBtn, 'error');
        } else {
          showError(msg);
        }
      });
    }

    /* ── bind eventi ── */

    /*
     * v5.2: usa on:variant:change invece di change su .original-selector.
     * L'evento è dispatched dal custom element variant-picker e bubbles fino
     * a formContainer. detail.variant.id contiene il nuovo variant ID (number).
     */
    formContainer.addEventListener('on:variant:change', function (evt) {
      currentJacketVariantId = evt.detail && evt.detail.variant
        ? String(evt.detail.variant.id)
        : null;
      update(currentJacketVariantId);
    });

    /*
     * Intercettazione submit in capture phase: il nostro listener gira PRIMA
     * dei listener aggiunti da product-form. stopImmediatePropagation() impedisce
     * al tema di fare la propria POST quando il paraschiena "Sì" è attivo.
     */
    form.addEventListener('submit', onSubmit, true);

    /* Inizializza con la variante già selezionata al caricamento pagina */
    var hiddenInput = form.querySelector('[name="id"]');
    if (hiddenInput && hiddenInput.value) {
      currentJacketVariantId = hiddenInput.value;
      update(currentJacketVariantId);
    }
  }

  /* ─── init ─── */

  function initAll() {
    document.querySelectorAll('.paraschiena-upsell').forEach(function (el) {
      if (!el.dataset.puInit) {
        el.dataset.puInit = '1';
        ParaschienaUpsell(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
